import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends, objectSpread2 as _objectSpread2, typeof as _typeof } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useState, useCallback } from 'react';
import svgIcons from './svg-icons.esm.js';
import useResponsiveValue from '../../../hooks/use-responsive-value.esm.js';
import { useSafeThemeUI } from '../../../theme-provider/use-theme-ui.esm.js';
import { get } from '../../../utils/object.esm.js';
import { getSvg, omitSvg } from '../../../utils/props-utils.esm.js';
import { resolveSize, isValidUnit, remToPx } from '../../../utils/size-utils.esm.js';
import { useUniqueId } from '../../../utils/unique-id.esm.js';
import Box from '../box/box.esm.js';
import FlexInline from '../flex/flex-inline.esm.js';
import Svg from '../svg/svg.esm.js';

var _excluded = ["id", "className", "size", "icon", "glowEffect", "highlight", "secondaryColor", "onHover", "openSize", "noWrapper", "children", "viewBox", "height", "width"];
var Icon = /*#__PURE__*/React.forwardRef(function Icon(props, ref) {
  var _ref, _remToPx, _ref2, _ref3;
  var theme = useSafeThemeUI(props);
  var id = props.id,
    className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? 'sm' : _props$size,
    icon = props.icon,
    glowEffect = props.glowEffect,
    highlight = props.highlight,
    secondaryColor = props.secondaryColor,
    onHover = props.onHover,
    openSize = props.openSize,
    noWrapper = props.noWrapper,
    children = props.children,
    viewBox = props.viewBox,
    height = props.height,
    width = props.width,
    rest = _objectWithoutProperties(props, _excluded);
  var identifier = id || useUniqueId('icon');
  var _iconSize = resolveSize(size, get(theme, 'sizes.icon'));
  var _size = Array.isArray(_iconSize) ? useResponsiveValue(_iconSize, {
    updateOnResizeChangeStopPeriod: 50
  }) : _iconSize;
  var _icon = (_ref = svgIcons[icon]) !== null && _ref !== void 0 ? _ref : 24;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHover = _useState2[0],
    setHover = _useState2[1];
  var handleMouseEnter = useCallback(function (event) {
    setHover(true);
    onHover && onHover(true, event.currentTarget);
  }, [onHover]);
  var handleMouseLeave = useCallback(function (event) {
    setHover(false);
    onHover && onHover(false, event.currentTarget);
  }, [onHover]);
  var useSize = typeof _icon.size === 'number' || isValidUnit(_icon.size);
  var iconSize = !openSize && useSize ? {
    size: (_remToPx = remToPx(_size)) !== null && _remToPx !== void 0 ? _remToPx : _icon.size
  } : {};
  var WrapperComponent = openSize ? Box : FlexInline;
  var content = /*#__PURE__*/React.createElement(Svg, _extends({
    role: "img",
    className: 'csg-tui-icon-svg',
    __css: {
      overflow: 'visible'
    }
  }, _objectSpread2(_objectSpread2({
    viewBox: viewBox !== null && viewBox !== void 0 ? viewBox : _icon.viewBox
  }, iconSize), !openSize && _typeof(_icon.size) === 'object' ? {
    width: (_ref2 = width) !== null && _ref2 !== void 0 ? _ref2 : _icon.size.width,
    height: (_ref3 = height) !== null && _ref3 !== void 0 ? _ref3 : _icon.size.height
  } : {})), highlight || glowEffect && isHover ? /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "glow-".concat(identifier)
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "2.5",
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  })))) : null, children !== null && children !== void 0 ? children : /*#__PURE__*/React.createElement(_icon.element, _extends({}, noWrapper ? rest : getSvg(rest), {
    secondaryColor: secondaryColor,
    filter: highlight || glowEffect && isHover ? "url(#glow-".concat(identifier, ")") : undefined
  })));
  return !noWrapper ? /*#__PURE__*/React.createElement(WrapperComponent, _extends({
    ref: ref,
    className: classNames('csg-tui-icon', className),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    alignSelf: 'center'
  }, iconSize.size ? {
    width: iconSize.size,
    height: iconSize.size
  } : {}), omitSvg(rest)), openSize ? {
    width: '100%'
  } : {}), (highlight || glowEffect && isHover) && secondaryColor ? {
    color: secondaryColor
  } : {})), content) : content;
});

export default Icon;
//# sourceMappingURL=icon.esm.js.map
